import { colors } from './colors';
import { radius } from './radius';
import { spacing } from './spacing';
import { typography } from './typography';

export const inputs = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    gap: spacing.xs,
    width: '100%',
  },
  base: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: radius.md,
    color: colors.textPrimary,
    fontFamily: typography.fontFamily.sans,
    fontSize: typography.fontSize.sm,
    padding: `${spacing.sm} ${spacing.md}`,
    transition: 'border-color 0.2s, box-shadow 0.2s',
    outline: 'none',
    width: '100%',
    minHeight: '48px', // 48dp minimum interactive component size compliance
  },
  states: {
    focus: {
      borderColor: colors.primary,
      boxShadow: `0 0 0 2px ${colors.primaryLight}`,
    },
    disabled: {
      backgroundColor: colors.surfaceMuted,
      color: colors.textMuted,
      cursor: 'not-allowed',
    },
    error: {
      borderColor: colors.errorText,
      boxShadow: `0 0 0 2px ${colors.error}`,
    }
  },
  label: {
    color: colors.textSecondary,
    fontSize: typography.fontSize.xs,
    fontWeight: typography.fontWeight.semibold,
  },
  errorText: {
    color: colors.errorText,
    fontSize: typography.fontSize.xs,
  }
};

export default inputs;
